import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createContainer } from '@dbk-legacy/muster/react';
import { View } from '@dbk/ui-react-utils';
import Text from '@dbk/ui-text';
import Button from '@dbk/ui-buttons';
import format from 'date-fns/format';
import { Tab, Tabs } from '@dbk/ui-tabs';
import ReportCategoryDocList from '../report-category-doclist/report-category-doclist';
import SortingHeader from '../../../../../../src/components/common/sorting-header';
import DateSelectionBar from '../../../../../../src/components/common/date-selection-bar';
import CalendarModal from '../../../../../../src/components/common/calendar-modal';
import SimpleDate from '../../../../../../src/components/common/date';
import styles from './report-statement-details.style';
import { SELECTED_RANGE, DURATION, DATE_RANGE } from '../constants';
import { DatePicker, Utils } from '@dbk/ui-datepicker';
import InverseProvider from '@dbk/ui-inverse';
import 'moment/min/locales';
import moment from 'moment';
import { LoadingCircle } from '../../../../../../src/components/common/loading';
// import Button from '@dbk/ui-buttons';
// import Dropdown from '../../../../../../src/components/common/dropdown';
import Dropdown from '@dbk/ui-dropdowns';

class ReportStatementDetails extends Component {
    constructor(props) {
        super(props);
        const { startDate, endDate } = this.props.reports;
    
        const currentDate = moment();
        const firstDayOfYear = moment().startOf('year');
        const range = this.props.reports.selectedReportDetailsDateRange === 2 ? true : false;
        const { i18n: { messages } } = this.props;
        this.state = {
            isDateRangeSelected: range,
            totalDocs7Days: 0,
            totalDocs30Days: 0,
            totalDocsCustomRange: 0,
            value: {
                from: startDate? moment(startDate).toDate() : new Date(firstDayOfYear),
                to: endDate? moment(endDate).toDate() : new Date(currentDate)
            },
            dropdownList: [
                { label: messages["app.incomehistory.7days"], value: 0},
                { label: messages["app.report.transactionHistory.30days"], value: 1},
                { label: messages["app.report.transactionHistory.90days"], value: 2},
                { label: this.props.reports.dropdownDateRangeText, value: 3}
            ],
        }
        // this.props.setStartDate(firstDayOfYear.format('YYYY-MM-DD'));
        // this.props.setEndDate(currentDate.format('YYYY-MM-DD'));

    }

    componentWillMount() {
        if (this.props.reports.openDateRangeTab) {
            this.props.setDataForNotificationList();
        }
    }

    componentDidUpdate() {
        
        if (this.props.reports.closeDatePicker === true
            && this.datepickerRef && this.datepickerRef.datepicker
            && this.datepickerRef.datepicker.state
            && this.datepickerRef.datepicker.state.isOpen) {
            this.onCancel();
        }
        if(this.state.value.from && this.state.value.to){
            setTimeout(() => {
              if(document.querySelector('#applybtnFocus')){
                    document.querySelector('#applybtnFocus').focus();
                }
            }, 100);
        }
    }

    componentWillUnmount() {
        // this.props.setStartDate(null);
        // this.props.setEndDate(null);

    }

    componentWillReceiveProps(nextProps) {
        if (this.props.reports.dropdownDateRangeText !== nextProps.reports.dropdownDateRangeText) {
          this.setDropdownList(nextProps.reports.dropdownDateRangeText);
        }
      }

    /**
   * function to set duration week/month/dates
   */
    setDuration = (index) => {
        let duration = '';
        switch (index) {
            case 0:
                duration = DURATION.LAST_WEEK;
                break;
            case 1:
                duration = DURATION.LAST_MONTH;
                break;
            case 2:
                duration = DURATION.LAST_90_DAYS;
                break;
            case 3:
                duration = DURATION.DATES
                break;
            default:
                duration = '';
                break
        }

        this.props.setDuration(duration);
    }

    /**
     * Method to handle onDone click in Calander Component
     */
    // onCustomDateRangeClicked = () => {
    //     this.props.fetchDocumentsForCategories()
    // }

    onDayClick = (selectionStart) => {
        const value = Utils.addDayToRange(
            selectionStart,
            this.state.value
        );
        this.setState({
            value,
        });
    };

    onChangeRange = (range) => {
        this.setState({
            value: {
                ...this.state.value,
                ...range,
            }
        });
    }

    setDropdownList = (selectDateLabel) => {
        const { i18n: { messages } } = this.props;
        this.setState({dropdownList: [
            { label: messages["app.incomehistory.7days"], value: 0},
            { label: messages["app.report.transactionHistory.30days"], value: 1},
            { label: messages["app.report.transactionHistory.90days"], value: 2},
            { label: `${selectDateLabel}`, value: 3}
        ]});
    }

    onApplyDateChange = () => {
        const dateSelDropdownText = `${moment(this.state.value.from).format('DD MMM YYYY')} - ${moment(this.state.value.to).format('DD MMM YYYY' )}`
        this.datepickerRef.close();
        this.props.setDatePickerClose(false);
        this.props.fetchDocumentsForCategories(moment(this.state.value.from).format('DD MMM YYYY'),
        moment(this.state.value.to).format('DD MMM YYYY' ));
        this.props.reports.setDropdownDateRangeText(dateSelDropdownText);
        this.props.reports.setDropdownPrevRangeSelected(SELECTED_RANGE.CUSTOM);
        this.props.setReportDetailDateRange(SELECTED_RANGE.CUSTOM);
    }

    onCancel = () => {
        this.datepickerRef.close();
        this.props.setDatePickerClose(false);
        if(this.props.reports.dropdownPrevRangeSelected !== SELECTED_RANGE.CUSTOM ){
            this.props.reports.setDropdownRangeSelected(this.props.reports.dropdownPrevRangeSelected);
        }
        this.setDropdownList(this.props.reports.dropdownDateRangeText)
    }

    customFooter = () => {
        const { i18n: { messages } } = this.props;

        return <InverseProvider inverse style={{ borderBottom: "1px solid #535b61", width: "100%", height: "60px", backgroundColor: '#12213c', paddingTop: "15px" ,display: "flex", justifyContent:"space-between",  paddingRight:"6px" }} >
            <div className='datepicker-footer-txt' tabIndex={0}>
                <Text style={{ padding: "5px" }}>{messages['app.chedelivery.reports.customReports.today']}{moment().format('DD-MMM-YYYY')}</Text>
            </div>
            <div className='datepicker-footer-btn'>
                <Button tertiary
                    onClick={() => this.onCancel()}
                >{messages['app.chedelivery.reports.customReports.cancelButton']}</Button>

                <Button
                    id="applybtnFocus"
                disabled={!(this.state.value.from && this.state.value.to)}
                    onClick={() => this.onApplyDateChange()}
                >{messages['app.chedelivery.reports.apply']}</Button>
            </div>
        </InverseProvider>
    }

    rangeDropdownhandler = (option) => {
        const { reports: { statement : { lastWeek, lastMonth, last90days }, selectedCategoryTabIndex}, setSelectedCategoryId, setSelectedCategoryName } = this.props;
        this.props.reports.setDropdownRangeSelected(option);

        switch(option) {
            case 0:
                this.props.reports.setDropdownPrevRangeSelected(option);
                this.props.setReportDetailDateRange(option);
                setSelectedCategoryId(lastWeek[selectedCategoryTabIndex].docCategoryId);
                setSelectedCategoryName(lastWeek[selectedCategoryTabIndex].docCategoryName);
                break;
            case 1:
                this.props.reports.setDropdownPrevRangeSelected(option);
                this.props.setReportDetailDateRange(option);
                setSelectedCategoryId(lastMonth[selectedCategoryTabIndex].docCategoryId);
                setSelectedCategoryName(lastMonth[selectedCategoryTabIndex].docCategoryName);
                break;
            case 2:
                this.props.reports.setDropdownPrevRangeSelected(option);
                this.props.setReportDetailDateRange(option);
                setSelectedCategoryId(last90days[selectedCategoryTabIndex].docCategoryId);
                setSelectedCategoryName(last90days[selectedCategoryTabIndex].docCategoryName);
                break;
            case 3:
                this.datepickerRef.open();
                break;
            default:
        }
        // this.props.setReportDetailDateRange(option);
        this.setDuration(option)
    }

    dropdownOpenHandler = () => {
        const { i18n: { messages } } = this.props;
        this.setDropdownList(messages["app.trade.filter.selectDate"]);
    }

    dropdownCloseHandler = () => {
        this.setDropdownList(this.props.reports.dropdownDateRangeText);
    }

    daysSelectionComp = () => {
        const { i18n: { messages } } = this.props;
        return (
            <div className="dropdown-datepicker">
                { !this.props.logoutPopup.isVisible &&  
                    <React.Fragment>
                        <div className="drop-down">
                            <Dropdown
                            size='large'
                            fullWidth
                            selected={this.props.reports.dropdownRangeSelected}
                            options={this.state.dropdownList}
                            defaultLabel={false}
                            onChange={(option) => {
                                this.rangeDropdownhandler(option);
                            }}
                            onDropdownOpen={this.dropdownOpenHandler}
                            onDropdownClose={this.dropdownCloseHandler}
                            ariaLabel={messages["app.trade.filter.selectDate"]}
                            />
                        </div>
                        <div className='date-picker'>
                            <DatePicker
                                tabIndex="0"
                                ref={(ref) => this.datepickerRef = ref}
                                showOutsideMonthDays={false}
                                tetherProps={{attachment : "top center", targetAttachment : "right center"}}
                                enableYearNavigation
                                enableRangeSelection
                                onChange={this.onChangeRange}
                                value={this.state.value}
                                startDate={moment(DATE_RANGE.DATE).toDate()}
                                endDate={moment().toDate()}
                                inputDateFormat={'dd MMM yyyy'}
                                selectionStart={this.state.value.from}
                                selectionEnd={this.state.value.to}
                                renderFooter={() => this.customFooter()}
                                locale={this.props.auth.langCode}
                                weekStartsOn={1} // Monday is the first day of the week.
                            />
                        </div>
                    </React.Fragment>
                }
            </div>
        )
    }

    render() {
        const { i18n: { messages },
            reports: { showSpinner, startDate, endDate, selectedReportDetailsDateRange, totalDocs30Days, totalDocs7Days, totalDocsCustomRange } } = this.props;
        let customRangeTotalDocs = '';
        if (totalDocsCustomRange > 0) {
            customRangeTotalDocs = ` (` + 
             + `)`;
        }
        if(document.querySelector('div.calendar')){
            document.querySelector('div.header').focus()
        }

        return (
            <View style={styles.container}>

                <div>
                    <SortingHeader
                        enabled={false}
                        showBorder={false}
                        messages={messages}
                    />
                    <View>
                        <ReportCategoryDocList daysSelectionComp = {this.daysSelectionComp} />
                    </View>

                </div>
            </View >
        );
    }
}
ReportStatementDetails.propTypes = {
    i18n: PropTypes.shape({
        messages: PropTypes.object,
    }),
    reports: PropTypes.shape({
        startDate: PropTypes.string,
        endDate: PropTypes.string,
    }),
};

ReportStatementDetails.defaultProps = {
    i18n: {},
    reports: {}
};

export default createContainer({

    $queries: {
        edelivery: {
            getUserPreferences: { $call: 'getUserPreferences' },
            showPrompt: true,
        },
        changePage: { $call: 'ui.history.push' },
        i18n: {
            messages: true,
        },
        getLastStatements: {
            $call: 'reports.getLastStatements',
        },
        getDocuments: {
            $call: 'reports.getDocuments',
        },
        // setRangeYTD: {
        //     $call: 'reports.setRangeYTD'
        // },
        setDuration: {
            $call: 'reports.setDuration'
        },
        setReportDetailDateRange: {
            $call: 'reports.setReportDetailDateRange'
        },
        setDataForNotificationList: {
            $call: 'reports.setDataForNotificationList'
        },
        fetchDocumentsForCategories: {
            $call: 'reports.fetchDocumentsForCategories'
        },
        reports: {
            showSpinner: true,
            lastMonthStatements: true,
            totalDocs7Days: true,
            totalDocs30Days: true,
            totalDocsCustomRange: true,
            statement: {
                lastWeek: true,
                lastMonth: true,
                last90days: true,
            },
            selectedReportDetailsDateRange: true,
            calendar: {
                open: {
                    $call: 'open'
                },
                ...CalendarModal.getFragment('calendarModal'),
            },
            startDate: true,
            endDate: true,
            closeDatePicker:true,
            dropdownDateRangeText: true,
            setDropdownDateRangeText: { $set: 'dropdownDateRangeText' },
            dropdownRangeSelected: true,
            setDropdownRangeSelected: { $set: 'dropdownRangeSelected'},
            dropdownPrevRangeSelected: true,
            setDropdownPrevRangeSelected: { $set: 'dropdownPrevRangeSelected'},
            selectedCategoryId: true,
            selectedCategoryTabIndex: true
        },
        setStartDate: { $set: 'reports.startDate' },
        setEndDate: { $set: 'reports.endDate' },
        auth: {
            langCode: true,
        },
        setDatePickerClose: {
            $set: 'reports.closeDatePicker'
          },
          logoutPopup: {isVisible : true},
        setSelectedCategoryId: { $set: 'reports.selectedCategoryId'},
        setSelectedCategoryName: { $set: 'reports.selectedCategoryName'}
    },
})(ReportStatementDetails);

